/**
 * Normalize a date string by rounding to the nearest minute
 * This helps with request deduplication by treating requests within the same minute as identical
 *
 * @param dateStr - Date string to normalize
 * @returns Normalized ISO string with seconds and milliseconds set to 0
 */
export const normalizeDateForCaching = (dateStr?: string): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  date.setSeconds(0, 0); // Reset seconds and milliseconds to 0
  return date.toISOString();
};

/**
 * Generate a cache key for request deduplication using normalized dates
 *
 * @param assetId - Asset identifier
 * @param startDate - Start date string
 * @param endDate - End date string
 * @returns Normalized cache key without seconds/milliseconds
 */
export const generateNormalizedCacheKey = (assetId: string, startDate?: string, endDate?: string): string => {
  const normalizedStartDate = normalizeDateForCaching(startDate);
  const normalizedEndDate = normalizeDateForCaching(endDate);

  // Remove seconds and milliseconds from the ISO string for cache key
  const removeSeconds = (isoString: string) => {
    if (!isoString) return '';
    return isoString.replace(/:\d{2}\.\d{3}Z$/, 'Z'); // Remove :SS.sssZ
  };

  const startKey = removeSeconds(normalizedStartDate);
  const endKey = removeSeconds(normalizedEndDate);

  return `${assetId}_${startKey}_${endKey}`;
};
